/**
 * API Client Configuration (Story 04-01)
 *
 * Frontend tunable for the request timeout enforced by `lib/api-client.ts`.
 * Every `fetch` issued through the LUDOKA API client aborts once this many
 * milliseconds elapse without a response, so a slow or dead link can never
 * leave a request hanging indefinitely and applying a late, stale response.
 */

const DEFAULT_API_TIMEOUT_MS = 15_000;

function parsePositiveInt(raw: string | undefined, fallback: number): number {
  if (!raw) return fallback;
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

/**
 * Milliseconds a `fetch` in `lib/api-client.ts` may run before it is aborted
 * and rejects with a `TimeoutError`. Configurable via `VITE_API_TIMEOUT_MS`.
 */
export const API_TIMEOUT_MS = parsePositiveInt(
  import.meta.env.VITE_API_TIMEOUT_MS,
  DEFAULT_API_TIMEOUT_MS
);
